export const CANDIDATE_FILTER_STORAGE_KEYS = [
  'filter_candidates_language',
  'filter_candidates_location',
  'filter_candidates_maxHourlyRate',
  'filter_candidates_maxAnnualRate',
  'filter_candidates_enableHourly',
  'filter_candidates_enableAnnual',
  'filter_candidates_enableNegotiable',
  'filter_candidates_enableCoverLetterVideoIncluded',
  'filter_candidates_enableBoth',
  'filter_jobs_keywords',
  'searchKeywords',
  'candidateSearchKeyword',
  'candidateSearchQuery',
  'can_page',
  'prev_can_page',
  'can_selected',
  'candidates_cache',
]

export const JOB_FILTER_STORAGE_KEYS = [
  'filter_jobs_language',
  'filter_jobs_location',
  'filter_jobs_duration',
  'filter_jobs_minHourlyRate',
  'filter_jobs_minAnnualRate',
  'filter_jobs_keywords',
  'jobSearchKeyword',
  'fj_page',
  'fj_selected',
  'find_jobs_cache',
]

export const isBrowserReload = () => {
  if (typeof performance === 'undefined') return false

  const navEntry = performance.getEntriesByType?.('navigation')?.[0]
  if (navEntry?.type) return navEntry.type === 'reload'

  return performance.navigation?.type === 1
}

const removeStorageKeys = (keys) => {
  if (typeof localStorage === 'undefined') return

  keys.forEach((key) => {
    localStorage.removeItem(key)
  })
}

export const clearPersistedCandidateFilters = () => {
  removeStorageKeys(CANDIDATE_FILTER_STORAGE_KEYS)
}

export const clearPersistedJobFilters = () => {
  removeStorageKeys(JOB_FILTER_STORAGE_KEYS)
}

export const clearPersistedSearchFilters = () => {
  clearPersistedCandidateFilters()
  clearPersistedJobFilters()
}
